export const convertProviderCriteriaToViewModel = (...[stages, services, specializations, identities]: any): any => ({
  stages: stages.data || undefined,
  services: services.data || undefined,
  specializations: specializations.data || undefined,
  identities: identities.data || undefined,
});
